import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, useLocation } from 'react-router-dom';
import './assets/css/App.css';
import './i18n/i18n';

import App from './App';
import { SearchProvider } from './contexts/SearchContext';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <BrowserRouter>
    <SearchProvider>
      <AnalyticsTracker />
      <App />
    </SearchProvider>
  </BrowserRouter>
);

// Zoho SalesIQ Integration
const zohoScript = document.createElement('script');
zohoScript.innerHTML = "window.$zoho=window.$zoho || {}; $zoho.salesiq=$zoho.salesiq||{ready:function(){}}";
document.body.appendChild(zohoScript);

// Load Zoho SalesIQ widget script
const zsiqScript = document.createElement('script');
zsiqScript.id = "zsiqscript";
zsiqScript.src = "https://salesiq.zohopublic.com/widget?wc=siqc8a6228899af406875326ceccc2468e99dc3389878a209a6d0261ac3e70bc6d3";
zsiqScript.defer = true;
document.body.appendChild(zsiqScript);

// Google Tag Manager
const gtmScript = document.createElement('script');
gtmScript.innerHTML = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':" +
  "new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0]," +
  "j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=" +
  "'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);" +
  "})(window,document,'script','dataLayer','GTM-T5SHWTKC');";
document.head.appendChild(gtmScript);

// Google Analytics (gtag.js)
const gaScript = document.createElement('script');
gaScript.async = true;
gaScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-HJ4M4BFJ83';
document.head.appendChild(gaScript);
gaScript.onload = () => {
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', 'G-HJ4M4BFJ83');
};

// Track route changes (page views)
function AnalyticsTracker() {
  const location = useLocation();
  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
    }
  }, [location.pathname, location.search]);
  return null;
}


